import { ValidationErrors } from '@angular/forms';

export const dateRangeInRangewithinAnotherDatesError: ValidationErrors = {
  dateRangeWithinAnotherDateRange: true,
};
